<template>
  <v-card flat class="tab-card">
    <div class="new-client-button-clear"></div>
    <v-row v-if="mounted" no-gutters>
      <v-expansion-panels>
        <v-expansion-panel class="search">
          <v-expansion-panel-title class="pa-3">
            <div id="excursion-list--filter-by-header">
              <v-icon class="text-grey-darken-2" icon="mdi-filter" />
              FILTER BY
            </div>
          </v-expansion-panel-title>
          <v-expansion-panel-text>
            <v-list>
              <v-list-subheader>General</v-list-subheader>
              <v-row class="ml-3" no-gutters>
                <v-col cols="5">
                  <v-text-field
                    id="excursion-list--excursion-filter-id-search--text-input"
                    v-model="searchExcursionId"
                    placeholder="Excursion ID"
                    class="excursion-filter-id excursion-filter-search excursion-input"
                    single-line
                    color="primary"
                    variant="underlined"
                    type="text"
                    :error-messages="excursionIdErrors"
                    @keyup.enter="getExcursionFilterData(true)"
                    @update:model-value="v$.searchExcursionId.$touch()"
                    @blur="v$.searchExcursionId.$touch()"
                  ></v-text-field>
                </v-col>
                <v-col cols="5">
                  <v-text-field
                    id="searchExcursionText"
                    v-model="searchExcursionKeyword"
                    placeholder="Search"
                    color="primary"
                    single-line
                    variant="underlined"
                    @click:append="getExcursionFilterData(true)"
                    @keyup.enter="getExcursionFilterData(true)"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row class="ml-3" no-gutters>
                <v-col cols="5">
                  <v-select
                    id="excursion-list--excursion-filter-excursion-type--selection"
                    v-model="searchExcursionType"
                    color="primary"
                    placeholder="Select Excursion Type"
                    variant="underlined"
                    :items="excursionTypeChoiceList"
                    @update:model-value="getExcursionFilterData(true)"
                  >
                    <template #item="data">
                      <v-list-item
                        v-bind="data.props"
                        :id="`excursion-list--excursion-type--option-${String(data.item).replaceAll(
                          ' ',
                          ''
                        )}`"
                      />
                    </template>
                  </v-select>
                </v-col>
                <v-col cols="5">
                  <v-select
                    id="excursion-list--excursion-filter-excursion-status--selection"
                    v-model="searchExcursionStatus"
                    color="primary"
                    placeholder="Select Excursion Status"
                    variant="underlined"
                    :items="excursionStatus"
                    @update:model-value="getExcursionFilterData(true)"
                  >
                    <template #item="data">
                      <v-list-item
                        v-bind="data.props"
                        :id="`excursion-list--excursion-status--option-${String(
                          data.item
                        ).replaceAll(' ', '')}`"
                      />
                    </template>
                  </v-select>
                </v-col>
              </v-row>
              <v-list-subheader v-if="excursionListFilterSectionDisplayed">Group</v-list-subheader>
              <v-row v-if="excursionListFilterSectionDisplayed" no-gutters class="ml-3">
                <v-col cols="12">
                  <v-autocomplete
                    id="excursion-list--search-clients"
                    v-model="searchClientSids"
                    v-model:search="searchClients"
                    label="Select one or more Clients"
                    :items="clientItems"
                    multiple
                    variant="underlined"
                    clearable
                    chips
                    hide-details
                    hide-selected
                    color="primary"
                    :closable-chips="true"
                    clear-icon="mdi-close"
                    item-title="name"
                    item-value="sid"
                    @focus="searchClients = null"
                  >
                    <template #item="data">
                      <v-list-item
                        v-bind="data.props"
                        :id="`excursion-list--excursion-status--option-${String(
                          data.item.name
                        ).replaceAll(' ', '')}`"
                      />
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
              <v-list-subheader>Integration</v-list-subheader>
              <v-row no-gutters class="ml-3">
                <v-col cols="3">
                  <v-text-field
                    id="excursion-list--search-vendor-excursion-sid"
                    v-model="searchVendorExcursionSid"
                    placeholder="Vendor Excursion SID"
                    single-line
                    type="text"
                    color="primary"
                    variant="underlined"
                    @keyup.enter="getExcursionFilterData"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row no-gutters class="ml-3 mt-3">
                <v-col>
                  <cs-button
                    id="excursion-list--search-button"
                    primary
                    left-icon="mdi-magnify"
                    label="Search"
                    @click="getExcursionFilterData(true)"
                  ></cs-button>
                  <cs-button
                    id="excursion-list--search-clear-button"
                    label="Clear"
                    @click="handleClearExcursionFilterButtonClick"
                  ></cs-button>
                </v-col>
              </v-row>
            </v-list>
          </v-expansion-panel-text>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>
    <v-data-table-server
      v-if="mounted"
      v-model:options="pagination"
      :headers="getExcursionTableHeaders()"
      :items="excursionList"
      class="excursion-table table-responsive"
      :items-per-page-options="itemsPerPageOptions"
      :items-per-page="pagination.itemsPerPage"
      :items-length="excursionListTotal"
      :loading="loading"
      :no-data-text="noDataText"
      hover
    >
      <template #item="{ item, index }">
        <tr>
          <td class="text-center excursion-id-cell">
            <a
              :id="`excursion-list--${String(item.name).replaceAll(' ', '')}--link-${index}`"
              :href="`/excursions/${item.id}`"
              >{{ item.id }}</a
            >
          </td>
          <td class="excursion-name-cell white-wrap-normal">
            <div class="excursion-list--padding-top">{{ item.name }}</div>
            <div class="excursion-list-created">
              <div class="excursion-list--padding-bottom">
                <span>
                  <stb-icon-tooltip location="right">
                    <template #activator="{ props }">
                      <span v-bind="props">
                        {{ userSegmentFromAuthor(item.user_email, item.author_display_name) }}
                      </span>
                    </template>
                    <span>
                      {{ emailAddressFromAuthor(item.user_email, item.author_display_name) }}
                    </span>
                  </stb-icon-tooltip>
                  ,&nbsp;{{ item.created_at }}
                </span>
              </div>
            </div>
          </td>
          <td class="text-center">
            <v-chip
              color="primary"
              variant="outlined"
              class="excursion-list--chip-size excursion-list--type"
            >
              {{ item.type }}
            </v-chip>
          </td>
          <td class="text-center">
            <v-chip
              color="#555757"
              variant="outlined"
              label
              class="excursion-list--chip-size excursion-list--status"
            >
              {{
                item.status ? item.status.substr(0, 1).toUpperCase() + item.status.substr(1) : ''
              }}
            </v-chip>
          </td>
          <td v-if="excursionListClientColumnDisplayed" class="text-left">
            {{ item.client_name }}
          </td>
          <td v-if="excursionListOrganisationNameColumnDisplayed" class="text-left">
            {{ item.parent_client_name }}
          </td>
          <td class="text-center">
            <stb-icon-tooltip
              :id="`excursion-list--btn-download-${index}`"
              icon-id="fa:fas fa-download"
              location="left"
              icon-size="x-small"
              clickable
              :disabled="item.status === 'draft'"
              icon-color="rgb(119, 119, 119)"
              @click="
                exportRiskAssessment(item.id, item.type, item.name, item.status, item.jurisdiction)
              "
            >
              <span v-if="item.status === 'draft'"
                >Exporting risk assessment is unavailable for 'Draft' excursions</span
              >
              <span v-if="item.status !== 'draft'">Export Risk Assessment</span>
            </stb-icon-tooltip>
            <stb-icon-tooltip
              v-if="excursionCopyDisplayed"
              :id="`excursion-list--btn-copy-${index}`"
              icon-id="fa:fas fa-copy"
              location="left"
              clickable
              icon-size="x-small"
              icon-color="rgb(119, 119, 119)"
              @click="openExcursionBeforeCopyDialog(item.id, item.type, item.name)"
            >
              <span>Copy Excursion</span>
            </stb-icon-tooltip>
          </td>
        </tr>
      </template>
    </v-data-table-server>
    <div>
      <cs-form-dialog
        id="dlg-excursions-copy-excursion"
        v-model="excursionBeforeCopyConfirmationDialogDisplayed"
        heading="Excursions - Copy Excursion"
        persistent
        :primary-action="{
          label: 'OK',
          eventName: 'primary-click',
          disabled: !continueBtnEnabled
        }"
        :secondary-action1="{ label: 'Cancel', eventName: 'secondary1-click' }"
        @primary-click="openExcursionCopy"
        @secondary1-click="closeExcursionCopy"
      >
        <template #cs-form-dialog-content>
          <v-card-text>
            <v-row class="mb-8 mt-1">
              {{ excursionBeforeCopyConfirmationDialogMessage }}
            </v-row>
            <v-row>
              <v-radio-group v-model="excursionCopySelection">
                <v-row class="excursion-convert-to-template" no-gutters>
                  <v-col>
                    <v-radio
                      id="convertToTemplateEnabled"
                      label="Copy excursion and convert to template"
                      color="primary"
                      value="1"
                    ></v-radio>
                  </v-col>
                </v-row>
                <v-row class="excursion-convert-to-template" no-gutters>
                  <v-col>
                    <v-radio
                      v-if="hasClientRelativeList"
                      id="convertToTemplateNotEnabled"
                      label="Copy excursion within this school"
                      color="primary"
                      value="2"
                    ></v-radio>
                    <v-radio
                      v-if="!hasClientRelativeList"
                      id="convertToTemplateNotEnabled"
                      label="Copy excursion"
                      color="primary"
                      value="2"
                    ></v-radio>
                  </v-col>
                </v-row>
                <v-row
                  v-if="hasClientRelativeList && clientRelativeListItems.length > 0"
                  class="excursion-convert-to-template excursion-copy-to-sibling"
                  no-gutters
                >
                  <v-col cols="8">
                    <v-radio
                      id="copyExcursionToSiblingEnabled"
                      label="Copy excursion to another school"
                      value="3"
                      color="primary"
                    ></v-radio>
                  </v-col>
                  <v-select
                    v-if="excursionCopySelection == 3"
                    id="selectedSiblingSchool"
                    v-model="siblingSchool"
                    class="sibling-school-select"
                    :items="clientRelativeListItems"
                    color="primary"
                    item-title="siblingSchoolname"
                    item-value="siblingSchoolname"
                    testing-id="selected-sibling-school"
                  >
                    <template #item="data">
                      <v-list-item
                        v-bind="data.props"
                        :id="`excursion-list--excursion-before-copy-confirmation-dialog--sibling-school--option-${data.item}`"
                      />
                    </template>
                  </v-select>
                </v-row>
              </v-radio-group>
            </v-row>
          </v-card-text>
        </template>
      </cs-form-dialog>
      <cs-form-dialog
        id="dlg-excursions-copy-excursion-status"
        v-model="copyExcursionGenericDialogDisplayed"
        heading="Excursions - Copy Excursion Status"
        body-id="excursion-list--copy-excursion-modal--generic-dialog"
        :primary-action="{ label: 'OK', eventName: 'primary-click' }"
        @primary-click="
          handlecopyExcursionGenericDialogOkButtonClick(copyExcursionGenericDialogMessage)
        "
      >
        <template #cs-form-dialog-content>
          <v-spacer></v-spacer>
          <div v-safe-html="copyExcursionGenericDialogMessage"></div>
        </template>
      </cs-form-dialog>
      <cs-form-dialog
        id="dlg-excursions-export-risk-assessment"
        v-model="riskAssessmentExportModalDisplayed"
        heading="Excursions - Export Risk Assessment"
        :primary-action="{
          label: 'Export PDF',
          eventName: 'primary-click',
          disabled: riskAssessmentDownloadActionInProgress,
          loading: riskAssessmentDownloadActionInProgress
        }"
        :secondary-action1="{
          label: 'Export DOC',
          eventName: 'secondary1-click',
          disabled: riskAssessmentDownloadActionInProgress,
          loading: riskAssessmentDownloadActionInProgress
        }"
        :secondary-action2="{ label: 'Cancel', eventName: 'secondary2-click' }"
        @primary-click="downloadAssessment(`pdf`)"
        @secondary1-click="downloadAssessment(`docx`)"
        @secondary2-click="close"
        @update:model-value="onDlgExportClose"
      >
        <template #cs-form-dialog-content>
          <v-card-text>
            <v-container class="export-excursion-policy">
              <div>
                <v-row class="selected-risk-container" no-gutters>
                  <v-col cols="1">
                    <v-checkbox
                      id="export-excursion-risk-assessment--export-all-checklists"
                      v-model="allChecklistsExported"
                      hide-details
                      class="excursion-policy-row-title-checkbox"
                      color="primary"
                    ></v-checkbox>
                  </v-col>
                  <v-col
                    id="export-excursion-risk-assessment--export-all-checklists--label"
                    class="excursion-policy-row-title"
                    @click="allChecklistsExported = !allChecklistsExported"
                    >Export All Checklists</v-col
                  >
                </v-row>
                <v-row class="selected-risk-container" no-gutters>
                  <v-col cols="1">
                    <v-checkbox
                      id="export-excursion-risk-assessment--pre-departure-checklist"
                      v-model="predepartureChecklistExported"
                      hide-details
                      class="excursion-policy-row-title-checkbox"
                      color="primary"
                    ></v-checkbox>
                  </v-col>
                  <v-col
                    id="export-excursion-risk-assessment--pre-departure-checklist--label"
                    class="excursion-policy-row-title"
                    @click="predepartureChecklistExported = !predepartureChecklistExported"
                    >Pre-Departure Checklist</v-col
                  >
                </v-row>
                <v-row class="selected-risk-container" no-gutters>
                  <v-col cols="1">
                    <v-checkbox
                      id="export-excursion-risk-assessment--all-attachments-checkbox"
                      v-model="allAttachmentsExported"
                      hide-details
                      class="excursion-policy-row-title-checkbox"
                      color="primary"
                    ></v-checkbox>
                  </v-col>
                  <v-col
                    id="export-excursion-risk-assessment--all-attachments--label"
                    class="excursion-policy-row-title"
                    @click="allAttachmentsExported = !allAttachmentsExported"
                    >Include All Attachments</v-col
                  >
                </v-row>
              </div>
            </v-container>
          </v-card-text>
        </template>
      </cs-form-dialog>
    </div>
    <page-loading-animation :displayed="loading"></page-loading-animation>
  </v-card>
</template>

<script>
import * as types from '@/store/mutationTypes';
import { numeric } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';
import excursionTypeInfo from '../lib/const/excursionTypeInfo';
import excursionStatus from '../lib/const/excursionStatus';
import trackableEvent from '../lib/const/trackableEvent';
import excursionTableColumn from '../lib/const/excursionTableColumn';
import { populateErrorMessage } from '../lib/errorMessages';
import StbIconTooltip from './StbIconTooltip';
import uniqBy from 'lodash/uniqBy';

export default {
  name: 'ExcursionList',

  components: { StbIconTooltip },

  validations() {
    return {
      searchExcursionId: {
        numeric
      }
    };
  },
  props: { excursionTemplateFlag: { type: Boolean, required: false, default: false } },
  setup: () => ({ v$: useVuelidate() }),
  data() {
    return {
      mounted: false,
      cacheResetFlag: false,
      debugFlag: false,
      propExcursionCopyModalRefreshed: true,
      excursionTypeName: '',
      excursionId: 0,
      excursionCopyModalDisplayed: false,
      search: '',
      querystringRefToTableColumnRefMap: {},
      tableColumnRefToQuerystringRefMap: {},
      itemsPerPageOptions: [10, 30, 50],
      pagination: {
        itemsPerPage: 30,
        page: 1,
        sortBy: ['']
      },
      excursionHeaders: [
        {
          title: excursionTableColumn.ID.label,
          key: excursionTableColumn.ID.tableColumnRef,
          headerProps: { class: 'text-start header text-xs-center' },
          sortable: false
        },
        {
          title: excursionTableColumn.DETAILS.label,
          key: excursionTableColumn.DETAILS.tableColumnRef,
          headerProps: { class: 'header' }
        },
        {
          title: excursionTableColumn.TYPE.label,
          key: excursionTableColumn.TYPE.tableColumnRef,
          headerProps: { class: 'header' },
          align: 'center',
          sortable: false
        },
        {
          title: excursionTableColumn.STATUS.label,
          key: excursionTableColumn.STATUS.tableColumnRef,
          headerProps: { class: 'header' },
          align: 'center',
          sortable: false
        }
      ],
      searchClientName: '',
      searchExcursionId: '',
      searchExcursionKeyword: '',
      searchVendorExcursionSid: '',
      searchExcursionType: null,
      searchExcursionStatus: null,
      searchClientSids: [],
      noDataText: 'No excursion was found',
      excursionBeforeCopyConfirmationDialogDisplayed: false,
      excursionBeforeCopyConfirmationDialogMessage:
        'Only the risk profile will be copied. All content and checked items will be created from scratch.',
      convertToTemplateEnabled: false,
      searchClients: '',
      clientSubdomain: '',
      excursionCopySelection: '2',
      siblingSchool: '',
      excursionName: '',
      copyExcursionGenericDialogDisplayed: false,
      copyExcursionGenericDialogMessage: '',
      copyExcursionGenericDialogSuccessMessage: 'The excursion has been copied.',
      riskAssessmentExportModalDisplayed: false,
      riskAssessmentDownloadActionInProgress: false,
      allChecklistsExported: true,
      predepartureChecklistExported: false,
      allAttachmentsExported: false,
      exportedExcursionDc: {}
    };
  },
  computed: {
    excursionIdErrors() {
      const errors = [];
      if (!this.v$.searchExcursionId.$dirty) return errors;
      if (this.v$.searchExcursionId.numeric.$invalid) {
        errors.push('Excursion ID must be a number');
      }
      return errors;
    },
    excursionListClientColumnDisplayed() {
      return (
        (this.$store.state.common.excursionListClientColumnDisplayed && !this.clientSubdomain) ||
        (this.clientSubdomain && this.parentClientSiteFlag)
      );
    },
    excursionListFilterSectionDisplayed() {
      return this.$store.state.common.excursionListFilterSectionDisplayed;
    },
    excursionList() {
      return this.$store.state.common.excursionsList.data;
    },
    excursionCopyDisplayed() {
      return (
        this.$store.state.common.excursionCopyActionEnabled &&
        this.$store.state.common.copyExcursionButtonDisplayed
      );
    },
    loading() {
      return this.$store.state.common.excursionsList.loading;
    },
    clientSetupLoading() {
      return this.$store.state.authorisation.isInitClientConfigInProgress;
    },
    excursionListTotal() {
      return this.$store.state.common.excursionsList.total;
    },
    clientItems() {
      const selectedClientItems = this.clientItems
        ? this.clientItems.filter((item) => this.searchClientSids.includes(item.sid))
        : [];
      let items;
      if (
        this.$store.state.common.excursionListAllClientSuggestionDisplayed &&
        !this.parentClientSiteFlag
      ) {
        items = this.$store.state.common.clientList.data.map((clientItem) => {
          return {
            sid: clientItem.sid,
            name: `${clientItem.sid} - ${clientItem.metadata.name}`
          };
        });
      } else {
        items = this.$store.state.common.clientClientList.items;
      }
      items = uniqBy([...selectedClientItems, ...items], 'sid');
      return items;
    },
    excursionTypeChoiceList() {
      return [
        excursionTypeInfo.DAY_EXCURSION.label,
        excursionTypeInfo.OVERNIGHT_EXCURSION.label,
        excursionTypeInfo.INTERNATIONAL_EXCURSION.label
      ];
    },
    excursionStatus() {
      return [
        this.capitalize(excursionStatus.DRAFT),
        this.capitalize(excursionStatus.SUBMITTED),
        this.capitalize(excursionStatus.APPROVED),
        this.capitalize(excursionStatus.ARCHIVED)
      ];
    },
    excursionListOrganisationNameColumnDisplayed() {
      const { clientParentId } = this.$store.state.common;
      return !this.clientSubdomain || (this.clientSubdomain && clientParentId);
    },
    parentClientSiteFlag() {
      return this.$store.state.common.parentClientSiteFlag;
    },
    hasClientRelativeList() {
      if (!this.clientSetupLoading) {
        const localClientRelativeList = this.$store.state.common.clientRelativeList;
        if (localClientRelativeList && localClientRelativeList.length > 0) {
          return true;
        }
        return false;
      }
      return false;
    },
    clientRelativeList() {
      const selectedExcursion = this.excursionList.filter(
        (item) => item.id === this.excursionId
      )[0];
      if (!this.clientSetupLoading && selectedExcursion) {
        const localClientRelativeList = this.$store.state.common.clientRelativeList;
        const siblingSchools = localClientRelativeList.filter(
          (item) => item.clientName !== selectedExcursion.client_name
        );
        return siblingSchools;
      }
      return [];
    },
    clientRelativeListItems() {
      if (this.hasClientRelativeList) {
        return this.clientRelativeList.map((item) => item.clientName);
      }
      return [];
    },
    continueBtnEnabled() {
      if (this.excursionCopySelection === '3' && this.siblingSchool === '') {
        return false;
      }
      return true;
    },
    selectedSiblingSchool() {
      const localClientRelativeList = this.$store.state.common.clientRelativeList;
      if (localClientRelativeList) {
        const localSelectedSiblingSchool = localClientRelativeList.filter(
          (item) => item.clientName === this.siblingSchool
        )[0];
        return localSelectedSiblingSchool;
      }
      return null;
    }
  },
  watch: {
    pagination: {
      handler() {
        this.getExcursionFilterData();
      },
      deep: true
    },
    excursionTemplateFlag() {
      this.resetExcursionFilter();
      this.getExcursionFilterData(true);
    },
    async searchClients(val) {
      await this.filterClients(val);
    }
  },
  async mounted() {
    const { hostname } = window.location;
    const uiBaseDomain = this.$app.env.UI_BASE_DOMAIN;
    this.clientSubdomain = hostname.substring(0, hostname.indexOf(uiBaseDomain) - 1);

    const { axiosInstance } = this.$app;
    await this.$store.dispatch('authorisation/validateAndSetUserTokenOrLogout', {
      query: this.$route.query,
      axiosInstance
    });

    Object.keys(excursionTableColumn).forEach((key) => {
      this.querystringRefToTableColumnRefMap[excursionTableColumn[key].querystringRef] =
        excursionTableColumn[key].tableColumnRef;
      this.tableColumnRefToQuerystringRefMap[excursionTableColumn[key].tableColumnRef] =
        excursionTableColumn[key].querystringRef;
    });

    if (Object.keys(this.$route.query).length !== 0) {
      const {
        'cache-reset-flag': parsedCacheResetFlag,
        'debug-flag': parsedDebugFlag,
        s: parsedSearchExcursionKeyword,
        's-excursion-id': parsedSearchExcursionId,
        's-excursion-type': parsedSearchExcursionType,
        's-vendor-client-sid': parsedSearchVendorExcursionSid,
        's-excursion-status': parsedSearchExcursionStatus,
        's-client-sids': parsedSearchClientSids,
        page: parsedSearchPage,
        length: parsedSearchLength,
        direction: parsedSearchDirection,
        order: parsedSortBy
      } = this.$route.query;

      this.cacheResetFlag = parsedCacheResetFlag === 'true';
      this.debugFlag = parsedDebugFlag === 'true';

      if (
        parsedSearchExcursionKeyword &&
        String(parsedSearchExcursionKeyword).trim().length !== 0
      ) {
        this.searchExcursionKeyword = parsedSearchExcursionKeyword;
      }

      if (!Number.isNaN(parseInt(parsedSearchExcursionId, 10))) {
        this.searchExcursionId = parseInt(parsedSearchExcursionId, 10);
      }

      if (
        excursionTypeInfo.DAY_EXCURSION.label === parsedSearchExcursionType ||
        excursionTypeInfo.OVERNIGHT_EXCURSION.label === parsedSearchExcursionType ||
        excursionTypeInfo.INTERNATIONAL_EXCURSION.label === parsedSearchExcursionType
      ) {
        this.searchExcursionType = parsedSearchExcursionType;
      }

      if (
        excursionStatus.DRAFT === parsedSearchExcursionStatus ||
        excursionStatus.SUBMITTED === parsedSearchExcursionStatus ||
        excursionStatus.APPROVED === parsedSearchExcursionStatus ||
        excursionStatus.ARCHIVED === parsedSearchExcursionStatus
      ) {
        this.searchExcursionStatus = parsedSearchExcursionStatus;
      }

      if (
        parsedSearchLength === '10' ||
        parsedSearchLength === '30' ||
        parsedSearchLength === '50'
      ) {
        this.pagination.itemsPerPage = parseInt(parsedSearchLength, 10);
      } else {
        this.pagination.itemsPerPage = 30;
      }

      if (!Number.isNaN(parseInt(parsedSearchPage, 10)) && parseInt(parsedSearchPage, 10) > 0) {
        this.pagination.page = parseInt(parsedSearchPage, 10);
      }

      if (
        excursionTableColumn.DETAILS.querystringRef === parsedSortBy ||
        excursionTableColumn.CLIENT.querystringRef === parsedSortBy ||
        excursionTableColumn.ORGANISATION.querystringRef === parsedSortBy
      ) {
        this.pagination.sortBy[0] = {
          key: this.querystringRefToTableColumnRefMap[parsedSortBy],
          order: 'asc'
        };
        if (parsedSearchDirection === 'DESC' || parsedSearchDirection === 'ASC') {
          this.pagination.sortBy[0].order = parsedSearchDirection.toLowerCase();
        }
      }

      if (
        Array.isArray(parsedSearchClientSids) &&
        parsedSearchClientSids.every((item) => !Number.isNaN(item))
      ) {
        this.searchClientSids = parsedSearchClientSids;
      } else if (!Number.isNaN(parseInt(parsedSearchClientSids, 10))) {
        this.searchClientSids = [parsedSearchClientSids];
      }

      if (String(parsedSearchVendorExcursionSid).trim().length > 0) {
        this.searchVendorExcursionSid = parsedSearchVendorExcursionSid;
      }
    }
    this.$app.eventPluginCommonAdapter.registerTrackableEvent(trackableEvent.EXCURSION_LIST_LOADED);

    const getExcursionsArgHash = {
      stbApiAdapter: this.$app.stbApiAdapter,
      store: this.$store,
      excursionId: 0
    };
    await this.$store.dispatch('common/getExcursions', getExcursionsArgHash);
    if (document.getElementById('cs-header--home-btn')) {
      document
        .getElementById('cs-header--home-btn')
        .addEventListener('click', () => this.handleHomeButtonClick());
    }

    this.mounted = true;
  },
  methods: {
    getExcursionTableHeaders() {
      const header = JSON.parse(JSON.stringify(this.excursionHeaders));
      if (this.excursionListClientColumnDisplayed) {
        header.splice(6, 0, {
          title: excursionTableColumn.CLIENT.label,
          key: excursionTableColumn.CLIENT.tableColumnRef,
          headerProps: { class: 'header' }
        });
      }

      if (this.excursionListOrganisationNameColumnDisplayed) {
        header.push({
          title: excursionTableColumn.ORGANISATION.label,
          key: excursionTableColumn.ORGANISATION.label,
          headerProps: { class: 'header' },
          sortable: false
        });
      }
      header.push({
        title: excursionTableColumn.ACTION.label,
        key: excursionTableColumn.ACTION.tableColumnRef,
        headerProps: { class: 'header text-xs-center' },
        align: 'center',
        sortable: false,
        width: '82px'
      });

      return header;
    },
    async getExcursionFilterData(pageResetTriggered = false) {
      if (pageResetTriggered) {
        this.resetPage();
      }

      if (!this.v$.$invalid) {
        this.$store.commit(types.COMMON_SET_EXCURSIONS_LIST_LOADING, true);
        const filterClientSids =
          this.searchClientSids && this.searchClientSids.length > 0 ? this.searchClientSids : '';
        const filterParam = {
          'excursion-template-flag': this.excursionTemplateFlag,
          s: this.searchExcursionKeyword,
          's-excursion-id': this.searchExcursionId,
          's-excursion-type': this.searchExcursionType || '',
          's-vendor-client-sid': this.searchVendorExcursionSid,
          's-excursion-status': this.searchExcursionStatus || '',
          's-client-sids': filterClientSids,
          page: this.pagination.page,
          length: this.pagination.itemsPerPage
        };

        if (this.cacheResetFlag) {
          filterParam['cache-reset-flag'] = true;
        }

        if (this.debugFlag) {
          filterParam['debug-flag'] = true;
        }
        const searchQuery = JSON.parse(JSON.stringify(filterParam));
        if (this.pagination.sortBy.length !== 0 && this.pagination.sortBy[0] !== '') {
          if (this.tableColumnRefToQuerystringRefMap[this.pagination.sortBy[0].key]) {
            filterParam.order = this.pagination.sortBy[0].key;
            filterParam.direction = this.pagination.sortBy[0].order.toUpperCase();
            searchQuery.order =
              this.tableColumnRefToQuerystringRefMap[this.pagination.sortBy[0].key];
            searchQuery.direction = filterParam.direction;
          }
        }

        Object.keys(filterParam).forEach((key) => {
          if (filterParam[key] === '' || undefined === filterParam[key]) {
            delete filterParam[key];
          }
        });
        Object.keys(searchQuery).forEach((key) => {
          if (searchQuery[key] === '' || undefined === searchQuery[key]) {
            delete searchQuery[key];
          }
        });

        const argHash = {
          stbApiAdapter: this.$app.stbApiAdapter,
          filterParam,
          store: this.$store
        };
        await this.$store.dispatch('common/getExcursionList', argHash);
        this.$store.commit(types.COMMON_SET_EXCURSIONS_LIST_LOADING, false);
        this.$router.replace({ query: searchQuery }, () => {});
      }
    },
    openExcursionBeforeCopyDialog(id, type, name) {
      this.excursionTypeName = type;
      this.excursionId = id;
      this.excursionName = name;
      this.excursionBeforeCopyConfirmationDialogDisplayed = true;
      this.convertToTemplateEnabled = false;
    },
    async openExcursionCopy() {
      this.excursionBeforeCopyConfirmationDialogDisplayed = false;

      const apiPayload = {
        'new-excursion-name': `Copy of ${this.excursionName}`
      };

      if (
        this.excursionCopySelection === '3' &&
        this.selectedSiblingSchool &&
        this.selectedSiblingSchool.clientSid
      ) {
        apiPayload['new-client-sid'] = this.selectedSiblingSchool.clientSid;
      }
      if (this.excursionCopySelection === '1') {
        apiPayload['new-excursion-template-flag'] = true;
      }
      const postExcursionCopiesApiArgHash = {
        id: this.excursionId,
        payload: apiPayload,
        store: this.$store
      };
      const postExcursionCopiesCbResponse = await this.$app.stbApiAdapter.postExcursionCopies(
        postExcursionCopiesApiArgHash
      );
      if (!postExcursionCopiesCbResponse.error) {
        this.copyExcursionGenericDialogMessage = this.copyExcursionGenericDialogSuccessMessage;
        this.copyExcursionGenericDialogDisplayed = true;
      } else {
        this.copyExcursionGenericDialogMessage = `Excursion cannot be copied. ${postExcursionCopiesCbResponse.message}.`;

        this.copyExcursionGenericDialogMessage = populateErrorMessage({
          message: this.copyExcursionGenericDialogMessage,
          store: this.$store
        });

        this.copyExcursionGenericDialogDisplayed = true;
      }
    },
    handlecopyExcursionGenericDialogOkButtonClick() {
      if (
        this.copyExcursionGenericDialogMessage === this.copyExcursionGenericDialogSuccessMessage
      ) {
        this.$router.go();
      }
      this.copyExcursionGenericDialogDisplayed = false;
    },
    closeExcursionCopy() {
      this.excursionBeforeCopyConfirmationDialogDisplayed = false;
      this.convertToTemplateEnabled = false;
    },
    capitalize(str) {
      return str
        .toLowerCase()
        .split(' ')
        .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
        .join(' ');
    },
    userSegmentFromAuthor(email, authorDisplayName) {
      let localEmail = email || authorDisplayName;
      if (localEmail) {
        localEmail = localEmail.substr(0, localEmail.indexOf('@'));
      } else {
        localEmail = '';
      }
      return localEmail;
    },
    emailAddressFromAuthor(email, authorDisplayName) {
      let localEmail = email || authorDisplayName;
      if (!localEmail) {
        localEmail = '';
      }
      return localEmail;
    },
    async filterClients(val) {
      const { excursionListAllClientSuggestionDisplayed } = this.$store.state.common;

      // eslint-disable-next-line no-param-reassign
      val = val || '';

      this.$store.commit(types.COMMON_SET_CLIENT_CLIENT_LIST_LOADING, true);
      const filterParam = {
        s: val,
        page: this.pagination.page,
        length: 5
      };
      Object.keys(filterParam).forEach((key) => {
        if (filterParam[key] === '') {
          delete filterParam[key];
        }
      });
      const store = this.$store;
      const argHash = {
        stbApiAdapter: this.$app.stbApiAdapter,
        filterParam,
        store
      };

      if (excursionListAllClientSuggestionDisplayed && !this.parentClientSiteFlag) {
        await this.$store.dispatch('common/getClientList', argHash);
      } else {
        await this.$store.dispatch('common/getClientClientList', argHash);
      }

      this.$store.commit(types.COMMON_SET_CLIENT_CLIENT_LIST_LOADING, false);
    },
    resetPage() {
      this.pagination.itemsPerPage = 30;
      this.pagination.page = 1;
      this.pagination.sortBy = [];
    },
    resetExcursionFilter() {
      this.cacheResetFlag = false;
      this.debugFlag = false;
      this.searchExcursionKeyword = '';
      this.searchExcursionId = '';
      this.searchExcursionType = null;
      this.searchExcursionStatus = null;
      this.resetPage();
      this.searchClientSids = [];
      this.searchVendorExcursionSid = '';
    },
    handleClearExcursionFilterButtonClick() {
      this.resetExcursionFilter();
      this.$router.replace({ query: null });
      this.getExcursionFilterData();
    },
    handleHomeButtonClick() {
      this.resetExcursionFilter();
      if (!(this.$route.query.page === '1' && this.$route.query.length === '30')) {
        this.$router.push(`/excursions?page=1&length=30`);
      }
    },
    close() {
      this.riskAssessmentDownloadActionInProgress = false;
      this.riskAssessmentExportModalDisplayed = false;
      this.allChecklistsExported = true;
      this.predepartureChecklistExported = false;
      this.allAttachmentsExported = false;
      this.exportedExcursionDc = {};
    },
    async downloadAssessment(format) {
      this.riskAssessmentDownloadActionInProgress = true;

      const trackableEventBaseArgHash =
        this.$app.excursionCommon.getRiskAssessmentTrackableEventBaseArgHash(
          this.$store.state.common.apiDataDefaultJurisdiction,
          this.exportedExcursionDc
        );
      const trackableEventOptionArgHash =
        this.$app.excursionCommon.getRiskAssessmentTrackableEventOptionArgHash();
      this.$app.eventPluginCommonAdapter.registerTrackableEvent(
        trackableEvent.RISK_ASSESSMENT_EXCURSION_RISK_ASSESSMENT_EXPORT,
        trackableEventBaseArgHash,
        trackableEventOptionArgHash
      );

      const { query } = this.$route;
      const clientLogoEnabled = !(query && query.referrer && query.referrer === 'pcg');

      const excursionCommonAdapter = new this.$app.excursionCommon.Adapter({
        store: this.$store,
        app: this.$app
      });

      await excursionCommonAdapter.downloadAssessment(
        this.exportedExcursionDc.id,
        query,
        this.allChecklistsExported,
        clientLogoEnabled,
        this.predepartureChecklistExported,
        this.allAttachmentsExported,
        format,
        this.$app.deviceDetector
      );

      this.close();
    },
    async exportRiskAssessment(id, type, name, status, jurisdiction) {
      this.exportedExcursionDc.id = id;
      this.exportedExcursionDc.name = name;
      this.exportedExcursionDc.typeId = type;
      this.exportedExcursionDc.status = status;
      const argHash = {
        stbApiAdapter: this.$app.stbApiAdapter,
        store: this.$store,
        queryParam: this.$route.query
      };
      await this.$store.dispatch('common/getDefaultJurisdiction', argHash);
      this.exportedExcursionDc.jurisdiction =
        jurisdiction === '' || jurisdiction === undefined
          ? this.$store.state.common.apiDataDefaultJurisdiction
          : jurisdiction;
      this.riskAssessmentExportModalDisplayed = true;
    },
    onDlgExportClose(boolShow) {
      if (!boolShow) {
        this.close();
      }
    }
  }
};
</script>
<style scoped>
.excursion-list--padding-top {
  padding-top: 5px;
}
.excursion-list-created {
  font-size: 9px;
  margin-top: 5px;
}

.excursion-list-created span {
  color: #9ea5a3;
}

.search .v-text-field .v-input__control {
  margin-right: 15px;
}
.search .v-btn {
  margin-left: 0px;
}

.search .v-select.v-select--chips .v-select__selections {
  min-height: 32px;
}

.search .v-icon {
  font-size: 28px;
  margin-right: 5px;
}
.excursion-convert-to-template {
  margin-top: 10px;
}
.excursion-detail-text .v-text-field.v-text-field--solo .v-input__control {
  margin-right: 0px;
}

.excursion-list--chip-size {
  height: 16px !important;
  font-size: 10px !important;
}

.excursion-list--type .v-chip__content {
  height: 16px;
  line-height: 16px;
}

.excursion-list--status {
  text-transform: uppercase;
}
.excursion-copy-to-sibling {
  position: relative;
}
.sibling-school-select {
  position: absolute;
  right: 0;
  width: 190px;
  top: -5px;
}
.excursion-list--btn-download:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.excursion-list--padding-bottom {
  padding-bottom: 5px;
}

.excursion-name-cell a {
  color: #c80063;
  text-decoration: none;
  padding-left: 8px;
}

.excursion-name-cell a:not([href]):not([tabindex]) {
  color: #c80063;
  text-decoration: none;
  padding-left: 8px;
}

.excursion-id-cell a {
  color: #c80063;
  cursor: pointer;
}

.excursion-table table > thead > tr > th:first-child {
  padding: 0 16px;
}

/*Override th css*/
.v-table thead th {
  font-weight: bolder;
  color: #000000;
}

.v-table > .v-table__wrapper tbody td {
  font-size: 13px !important;
  font-weight: 400 !important;
  padding: 0 5px;
}

.tab-card {
  padding: 20px 0px;
  border-radius: unset !important;
}

.theme--light.v-tabs__bar {
  width: unset;
}

.v-tabs__item:not(.v-tabs__item--active) {
  opacity: unset;
}

.theme--light.v-tabs__bar .v-tabs__div {
  color: #9ca7a2;
}

.theme--light.v-tabs__bar .v-tabs__div .v-tabs__item--active {
  color: #000000;
  background: #ffffff;
}

.search .filter-by {
  margin-right: 15px;
  line-height: 38px;
  max-width: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.excursion-table .v-input__control .v-input__slot {
  background: unset;
}

.v-table thead td:not(:nth-child(1)),
.v-table tbody td:not(:nth-child(1)),
.v-table thead th:not(:nth-child(1)),
.v-table tbody th:not(:nth-child(1)),
.v-table thead td:first-child,
.v-table tbody td:first-child,
.v-table thead th:first-child,
.v-table tbody th:first-child {
  padding: 0 5px;
}

.v-messages__message {
  margin-left: -10px;
  margin-top: 8px;
  position: absolute;
}

.excursion-detail-text .v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: unset;
  height: 23px;
}

.excursions-content-padding {
  padding-top: 10px;
  padding-left: 24px;
  padding-right: 24px;
}

.search .v-expansion-panel__header {
  padding: 12px 16px;
}

.search .v-list {
  padding: 0px 0px 10px 0px;
}

.search .v-text-field__details {
  overflow: visible;
}

.update-provider-stepper-button {
  padding: 4px 0 0px 0;
}
.update-provider-stepper-button button {
  margin: 12px 8px 19px 0;
}
.excursions-navigator {
  height: 55px;
  margin-top: 14px;
}
.excursions-navigator-link {
  color: #9ca7a2 !important;
  text-decoration: unset;
  padding: 13px;
  font-weight: 500;
}
.excursions-navigator-link:hover {
  text-decoration: unset;
  border-bottom: 3px solid #c80063;
  color: #000000 !important;
}

.excursions-navigator-link-active {
  color: #000000 !important;
  border-bottom: 3px solid #c80063;
}

.table-responsive .v-table__overflow {
  background-image:
    linear-gradient(to right, white, white), linear-gradient(to right, white, white),
    linear-gradient(to right, rgba(0, 0, 20, 0.5), rgba(255, 255, 255, 0)),
    linear-gradient(to left, rgba(0, 0, 20, 0.5), rgba(255, 255, 255, 0));
  /* Shadows */
  /* Shadow covers */
  background-position:
    left center,
    right center,
    left center,
    right center;
  background-position:
    left center,
    right center,
    left center,
    right center;
  background-repeat: no-repeat;
  background-size:
    20px 100%,
    20px 100%,
    10px 100%,
    10px 100%;
  background-attachment: local, local, scroll, scroll;
}

.table-responsive .theme--light.v-table {
  background-color: unset;
}

.white-wrap-normal {
  white-space: nowrap;
}

.excursion-table .copy-icon {
  color: #777777;
}

.excursion-table :deep(.header) {
  font-size: 12px !important;
  font-weight: bolder !important;
  color: #000 !important;
  padding: 0 5px;
}

.text-start.header.text-xs-center {
  text-align: center !important;
}

:deep(.filter-by-client-field .mdi-close) {
  color: rgb(var(--v-theme-primary));
}

:deep(.v-expansion-panel-title:hover .v-expansion-panel-title__overlay) {
  opacity: 0 !important;
}

.selected-risk-container {
  max-height: 400px;
  height: 40px;
}

.excursion-policy-row-title {
  line-height: 60px;
  cursor: pointer;
  margin-left: 10px;
}

.excursion-policy-row-title:hover {
  cursor: pointer;
}
</style>
